import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import OfferForm from "../form/offer-form";
import { useEditOffer } from "./hooks";
import Modals from "../../../components/modal";
import { setLanguage } from "../../../utils/auth";
import { useUser } from "../../../common-hooks/user";

const EditOffer = ({ offer }) => {
  const {
    editOfferLoading,
    handleEditOffer,
    isOpenModal,
    toggleModal,
    selectedOffer,
    getOfferFieldData,
    handleLanguageData,
  } = useEditOffer(offer);

  const { isAdmin } = useUser();

  if (!isAdmin) {
    return null;
  }

  return (
    <div>
      <Tooltip title="Edit" placement="bottom">
        <i
          className={`fa fa-edit icon-btn-action`}
          onClick={() => {
            setLanguage("en");
            getOfferFieldData();
          }}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <OfferForm
              handleOfferForm={handleEditOffer}
              btn="Save"
              fieldValues={selectedOffer}
              isLoading={editOfferLoading}
              handleLanguageData={handleLanguageData}
            />
          }
          title="Edit Offer"
        />
      ) : null}
    </div>
  );
};

export default EditOffer;
